import { Alert, AlertTitle, Typography } from "@mui/material"

export function GrantWarning({ item: warning }) {
    return (
        <Alert severity={warning.severity} data-cy={`grant-warning-${warning.key}`}>
            <AlertTitle>{warning.title}</AlertTitle>
            <Typography variant="body2">{warning.message}</Typography>
        </Alert>
    )
}
